import CrudApiClient from '../crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { MetaQuery } from '@refinedev/core';
import { axiosInstance } from '../axios';
import { IDeliveryChallanItemUploadInput } from '@admin-panel/types';

class DCItemUploadAPIClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/deliverychallan/:deliveryChallanId/item');
  }

  async search(query: any, page: number, size: number): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async create(payload: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async updateById(id: any, data: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async findBulk(ids: any[]): Promise<any> {
    throw new Error('Unimplemented method');
  }

  async findById(id: any): Promise<any> {
    throw new Error('Unimplemented method');
  }

  // @ts-ignore
  async createMany(
    items: IDeliveryChallanItemUploadInput[],
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      const { deliveryChallanId }: any = meta;
      const dcItemUploadRequest: any = {
        skus: items,
      };

      const url = this.baseURL?.replace(':deliveryChallanId', deliveryChallanId);
      const response = await axiosInstance.post(`${url}/upload`, dcItemUploadRequest);
      return this.transformList(response.data.data);
    } catch (error) {
      console.error(`Error creating entities in bulk:`, error);
      throw error;
    }
  }
}

export default DCItemUploadAPIClient;
